export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      potential: 'Potencial Energético',
      infrastructure: 'Infraestructura',
      phases: 'Fases',
      products: 'Productos',
      partnerships: 'Alianzas',
      documents: 'Documentos',
      contact: 'Contacto',
    },
    home: {
      hero: {
        title: 'Paraguana Hydrogen Gateway',
        subtitle: 'Hidrógeno verde con escala y salida real al mercado',
        text: 'Paraguaná combina recurso renovable complementario (viento + sol), infraestructura disponible y una ubicación logística privilegiada para habilitar un corredor competitivo de moléculas verdes para el Caribe y el Atlántico.',
        bullets: [
          'Recurso eólico y solar de alto potencial',
          'Infraestructura industrial y logística portuaria existente',
          'Escalabilidad por fases (100 MW → 1 GW → 5 GW)',
          'Rutas comerciales: H₂ / amoníaco verde / metanol verde'
        ],
        ctaDataRoom: 'Solicitar Data Room',
        ctaMeeting: 'Agendar reunión',
      },
      whyParaguanaNEW: {
        title: 'Un hub natural para moléculas verdes',
        text: 'La propuesta se apoya en tres pilares: recurso renovable, infraestructura y ubicación. Juntos, reducen fricción de despliegue y habilitan una ruta creíble hacia escala industrial.',
        cards: [
          {
            title: 'Recurso renovable',
            description: 'Viento y sol con potencial de complementariedad para perfiles energéticos más estables.'
          },
          {
            title: 'Infraestructura',
            description: 'Ecosistema industrial, conectividad energética y experiencia operativa de la región.'
          },
          {
            title: 'Ubicación',
            description: 'Acceso marítimo con conectividad eficiente hacia hubs del Caribe y rutas Atlánticas.'
          }
        ]
      },
      energyPotential: {
        title: 'Energía renovable complementaria para operación industrial',
        text: 'La complementariedad viento + sol favorece un perfil de generación más estable, lo que permite diseñar una operación más eficiente y con mayor utilización de electrolizadores.',
        dataCards: [
          { label: 'Solar', value: '~6.5 kWh/m²/día', color: 'solar' },
          { label: 'Viento', value: '~9.7 m/s a 50 m', color: 'wind' },
          { label: 'Oleaje (potencial)', value: '~2.5–4.0 m', color: 'wave' }
        ],
        enablesTitle: 'Qué habilita:',
        enables: [
          'Mayor disponibilidad energética → mayor factor de utilización',
          'Menor presión sobre almacenamiento masivo',
          'Mejor base para contratos de suministro (offtake)'
        ],
        disclaimer: 'Valores referenciales del baseline del proyecto; sujetos a validación mediante campañas de medición e ingeniería.'
      },
      infrastructure: {
        title: 'Menos greenfield, más velocidad de ejecución',
        text: 'La presencia de infraestructura y experiencia industrial reduce complejidad de implementación y facilita una estrategia de despliegue por fases, alineada con hitos técnicos, permisos y acuerdos comerciales.',
        bullets: [
          'Integración con infraestructura energética disponible (según ingeniería)',
          'Ecosistema industrial y capacidad operativa local',
          'Ruta logística con potencial de adaptación para exportación',
          'Enfoque en seguridad, confiabilidad y trazabilidad desde el diseño'
        ]
      },
      exportRoutes: {
        title: 'Ubicación con conectividad marítima eficiente',
        text: 'Paraguaná se beneficia de rutas cortas hacia mercados del Caribe y conexión al corredor Atlántico, facilitando modelos de exportación escalables según producto (H₂ / NH₃ / metanol).',
        routes: [
          { destination: 'Cartagena', time: '~1 día' },
          { destination: 'Miami', time: '~3 días' },
          { destination: 'Rotterdam', time: '~9–10 días' }
        ],
        note: 'Tiempos referenciales sujetos a ruta, naviera y condiciones operativas.'
      },
      phases: {
        title: 'Escala modular: del primer despliegue a gigavatios',
        text: 'Una estrategia por fases permite coordinar infraestructura, tecnología, permisos y acuerdos comerciales, con un crecimiento ordenado y verificable.',
        items: [
          { phase: 'Fase 1 (2026–2028)', capacity: '100 MW', production: '~15.000 t/año H₂' },
          { phase: 'Fase 2 (2029–2031)', capacity: '1 GW', production: '~150.000 t/año H₂' },
          { phase: 'Meta 2035', capacity: '5 GW', production: '~750.000 t/año H₂' }
        ],
        close: 'Cada fase habilita capacidades adicionales de producción, logística y exportación.'
      },
      products: {
        title: 'Tres rutas comerciales según mercado y logística',
        cards: [
          {
            name: 'H₂ (Hidrógeno)',
            description: 'Para consumo industrial y aplicaciones energéticas donde la proximidad y la confiabilidad importan.'
          },
          {
            name: 'NH₃ (Amoníaco verde)',
            description: 'Vector logístico eficiente y puerta a mercados industriales.'
          },
          {
            name: 'Metanol verde',
            description: 'Ruta clave para shipping y química, con modelos de demanda en expansión.'
          }
        ]
      },
      sustainability: {
        title: 'Trazabilidad y responsabilidad desde el diseño',
        text: 'El proyecto prioriza prácticas de sostenibilidad y cumplimiento, con enfoque en trazabilidad, estándares de certificación y gestión responsable de recursos.',
        bullets: [
          'Cadena de custodia y trazabilidad de producción',
          'Enfoque en certificación y estándares aplicables',
          'Gestión responsable de recursos y permisos ambientales'
        ]
      },
      partnerships: {
        title: 'Un proyecto diseñado para socios',
        text: 'Paraguana Hydrogen Gateway se estructura para colaboración con compradores, tecnología, logística, capital e instituciones, con un enfoque de ejecución por fases y gobernanza clara.',
        blocks: [
          { title: 'Offtakers', description: 'contratos de compra y especificaciones de producto' },
          { title: 'Tecnología/EPC', description: 'electrólisis, integración, O&M' },
          { title: 'Logística/Navieras', description: 'soluciones de transporte y terminales' },
          { title: 'Financieros', description: 'deuda, equity, blended finance' },
          { title: 'Institucional', description: 'marco habilitante y coordinación' }
        ]
      },
      documentsSection: {
        title: 'Biblioteca de documentos',
        text: 'Accede a material comercial, técnico e institucional. Algunos documentos requieren solicitud de Data Room.',
        items: [
          { name: 'Resumen Ejecutivo', type: 'Comercial' },
          { name: 'One-pager técnico', type: 'Técnico' },
          { name: 'Roadmap por fases', type: 'Comercial' },
          { name: 'Nota institucional/regulatoria', type: 'Institucional' }
        ],
        ctaViewAll: 'Ver biblioteca completa'
      },
      finalCta: {
        title: 'Conversemos sobre offtake, alianzas o inversión',
        text: 'Cuéntanos tu interés y coordinamos una reunión.',
        cta: 'Contactar ahora'
      },
      visionShowcase: {
        eyebrow: 'La visión integrada',
        title: 'Sol, viento, industria y océano — un solo corredor verde',
        text: 'Paraguaná integra generación renovable, capacidad industrial y salida marítima directa. Todo lo necesario para producir y exportar moléculas verdes a escala.',
        chips: ['Solar + Eólica', 'Industria activa', 'Puerto de exportación', 'Ruta molecular H₂']
      },
      coastShowcase: {
        eyebrow: 'De la costa al mundo',
        title: 'Una península hecha para ser el nodo verde del Caribe',
        text: 'Costa árida, sol intenso, vientos constantes y aguas profundas. La geografía de Paraguaná ya está preparada para conectar producción con demanda global.'
      }
    },
    pages: {
      potential: {
        title: 'Potencial Energético',
        intro: 'Esta sección presenta el baseline técnico y el enfoque de validación del recurso renovable para soportar decisiones de ingeniería y escalamiento.',
        disclaimer: 'Gráficos y curvas ilustrativas; se reemplazan por datos medidos y modelados en etapa de ingeniería.'
      },
      infrastructure: {
        title: 'Infraestructura & Logística',
        intro: 'Una estrategia de despliegue realista combina infraestructura disponible, logística marítima y estándares operativos de seguridad y confiabilidad.'
      },
      phases: {
        title: 'Escalabilidad por Fases',
        intro: 'La hoja de ruta por fases alinea permisos, ingeniería, tecnología y acuerdos comerciales para habilitar crecimiento ordenado.'
      },
      products: {
        title: 'Productos',
        intro: 'El portafolio se adapta a las necesidades del mercado y la logística: H₂, NH₃ y metanol verde.'
      },
      partnerships: {
        title: 'Alianzas',
        intro: 'Buscamos socios para acelerar la ejecución: offtakers, tecnología/EPC, logística, capital e instituciones.'
      },
      documents: {
        title: 'Documentos',
        intro: 'Material comercial, técnico e institucional. Solicita el Data Room para acceder a documentación ampliada.'
      },
      contact: {
        title: 'Contacto',
        intro: 'Escríbenos para coordinar una reunión o solicitar el Data Room.'
      }
    },
    form: {
      name: 'Nombre',
      company: 'Empresa',
      country: 'País',
      interest: 'Interés',
      email: 'Email',
      message: 'Mensaje',
      submit: 'Enviar solicitud',
      submitting: 'Enviando...',
      success: 'Solicitud enviada correctamente',
      error: 'Error al enviar. Intenta nuevamente.',
      interests: {
        offtake: 'Offtake',
        investment: 'Inversión',
        epc: 'EPC-Tech',
        logistics: 'Logística',
        institutional: 'Institucional'
      }
    },
    footer: {
      tagline: 'La puerta verde del Caribe',
      description: 'Plataforma de hidrógeno verde con escala industrial y conectividad marítima estratégica.',
      copyright: '© 2026 Paraguana Hydrogen Gateway. Todos los derechos reservados.',
      privacy: 'Política de Privacidad'
    }
  },
  en: {
    nav: {
      home: 'Home',
      potential: 'Energy Potential',
      infrastructure: 'Infrastructure',
      phases: 'Phases',
      products: 'Products',
      partnerships: 'Partnerships',
      documents: 'Documents',
      contact: 'Contact',
    },
    home: {
      hero: {
        title: 'Paraguana Hydrogen Gateway',
        subtitle: 'Export-ready green hydrogen at scale',
        text: 'Paraguaná brings together complementary renewables (wind + solar), available infrastructure, and a strategic maritime location to enable a competitive green molecules corridor for Caribbean and Atlantic markets.',
        bullets: [
          'High-potential wind and solar resource',
          'Existing industrial and port logistics base',
          'Phased scale-up (100 MW → 1 GW → 5 GW)',
          'Market pathways: H₂ / green ammonia / green methanol'
        ],
        ctaDataRoom: 'Request Data Room',
        ctaMeeting: 'Book a meeting',
      },
      whyParaguanaNEW: {
        title: 'A natural hub for green molecules',
        text: 'The project stands on three pillars—renewable resource, infrastructure, and location—working together to reduce deployment friction and support a credible path to industrial scale.',
        cards: [
          {
            title: 'Renewable resource',
            description: 'Wind and solar complementarity to support steadier energy profiles.'
          },
          {
            title: 'Infrastructure',
            description: 'Industrial ecosystem, energy connectivity, and operational know-how in the region.'
          },
          {
            title: 'Location',
            description: 'Maritime access with efficient connectivity to Caribbean hubs and Atlantic routes.'
          }
        ]
      },
      energyPotential: {
        title: 'Complementary renewables for industrial operation',
        text: 'Wind + solar complementarity supports a more stable generation profile, enabling a more efficient design and higher electrolyzer utilization.',
        dataCards: [
          { label: 'Solar', value: '~6.5 kWh/m²/day', color: 'solar' },
          { label: 'Wind', value: '~9.7 m/s at 50 m', color: 'wind' },
          { label: 'Wave (potential)', value: '~2.5–4.0 m', color: 'wave' }
        ],
        enablesTitle: 'What this enables:',
        enables: [
          'Higher availability → higher utilization rates',
          'Reduced reliance on large-scale storage',
          'Stronger foundation for offtake agreements'
        ],
        disclaimer: 'Indicative baseline figures; subject to validation through measurement campaigns and engineering.'
      },
      infrastructure: {
        title: 'Less greenfield, faster execution',
        text: 'Available infrastructure and industrial know-how reduce implementation complexity and support a phased deployment aligned with technical milestones, permitting, and commercial agreements.',
        bullets: [
          'Integration with available energy infrastructure (engineering-driven)',
          'Industrial ecosystem and local operational capability',
          'Logistics pathway with an upgrade route for exports',
          'Safety, reliability, and traceability by design'
        ]
      },
      exportRoutes: {
        title: 'Efficient maritime connectivity',
        text: 'Paraguaná benefits from short routes to Caribbean markets and access to Atlantic corridors, supporting scalable export models depending on product (H₂ / NH₃ / methanol).',
        routes: [
          { destination: 'Cartagena', time: '~1 day' },
          { destination: 'Miami', time: '~3 days' },
          { destination: 'Rotterdam', time: '~9–10 days' }
        ],
        note: 'Indicative only; depends on route, carrier, and operating conditions.'
      },
      phases: {
        title: 'Modular scale: from first deployment to gigawatts',
        text: 'A phased strategy coordinates infrastructure, technology, permitting, and commercial agreements—supporting orderly and verifiable growth.',
        items: [
          { phase: 'Phase 1 (2026–2028)', capacity: '100 MW', production: '~15,000 t/year H₂' },
          { phase: 'Phase 2 (2029–2031)', capacity: '1 GW', production: '~150,000 t/year H₂' },
          { phase: '2035 Target', capacity: '5 GW', production: '~750,000 t/year H₂' }
        ],
        close: 'Each phase unlocks additional production, logistics, and export capability.'
      },
      products: {
        title: 'Three pathways based on market and logistics',
        cards: [
          {
            name: 'H₂ (Hydrogen)',
            description: 'For industrial demand and energy applications where proximity and reliability matter.'
          },
          {
            name: 'NH₃ (Green ammonia)',
            description: 'Logistics-friendly vector and gateway to industrial markets.'
          },
          {
            name: 'Green methanol',
            description: 'A key route for shipping and chemicals, with growing demand models.'
          }
        ]
      },
      sustainability: {
        title: 'Traceability and responsibility by design',
        text: 'The project prioritizes sustainability and compliance practices, focusing on traceability, certification-aligned standards, and responsible resource management.',
        bullets: [
          'Chain-of-custody and production traceability',
          'Certification-aligned approach and applicable standards',
          'Responsible resource management and permitting'
        ]
      },
      partnerships: {
        title: 'Built for partners',
        text: 'Paraguana Hydrogen Gateway is structured for collaboration with offtakers, technology, logistics, capital, and institutions—supported by phased execution and clear governance.',
        blocks: [
          { title: 'Offtakers', description: 'purchase agreements and product specs' },
          { title: 'Technology/EPC', description: 'electrolysis, integration, O&M' },
          { title: 'Logistics/Shipping', description: 'transport and terminal solutions' },
          { title: 'Financial partners', description: 'debt, equity, blended finance' },
          { title: 'Institutional', description: 'enabling framework and coordination' }
        ]
      },
      documentsSection: {
        title: 'Document library',
        text: 'Access commercial, technical, and institutional material. Some documents require a Data Room request.',
        items: [
          { name: 'Executive Summary', type: 'Commercial' },
          { name: 'Technical one-pager', type: 'Technical' },
          { name: 'Phased roadmap', type: 'Commercial' },
          { name: 'Institutional/regulatory note', type: 'Institutional' }
        ],
        ctaViewAll: 'View full library'
      },
      finalCta: {
        title: "Let's talk offtake, partnerships, or investment",
        text: "Share your interest and we'll schedule a meeting.",
        cta: 'Contact now'
      },
      visionShowcase: {
        eyebrow: 'The integrated vision',
        title: 'Sun, wind, industry, and ocean — one green corridor',
        text: 'Paraguaná combines renewable generation, industrial capacity, and direct maritime access. Everything needed to produce and export green molecules at scale.',
        chips: ['Solar + Wind', 'Active industry', 'Export port', 'H₂ molecular route']
      },
      coastShowcase: {
        eyebrow: 'From coast to the world',
        title: 'A peninsula built to be the Caribbean green node',
        text: 'Arid coast, intense sun, steady winds and deep waters. Paraguaná\'s geography is ready to connect production with global demand.'
      }
    },
    pages: {
      potential: {
        title: 'Energy Potential',
        intro: 'This section outlines the technical baseline and validation approach for renewable resources to support engineering and scale-up decisions.',
        disclaimer: 'Charts and curves are illustrative; to be replaced with measured and engineered datasets.'
      },
      infrastructure: {
        title: 'Infrastructure & Logistics',
        intro: 'A realistic deployment strategy combines available infrastructure, maritime logistics, and operational standards for safety and reliability.'
      },
      phases: {
        title: 'Phased Scale-Up',
        intro: 'A phased roadmap aligns permitting, engineering, technology, and commercial agreements to enable orderly growth.'
      },
      products: {
        title: 'Products',
        intro: 'The portfolio aligns with market needs and logistics: H₂, NH₃, and green methanol.'
      },
      partnerships: {
        title: 'Partnerships',
        intro: 'We partner to accelerate execution: offtakers, technology/EPC, logistics, capital, and institutions.'
      },
      documents: {
        title: 'Documents',
        intro: 'Commercial, technical, and institutional material. Request the Data Room for expanded documentation.'
      },
      contact: {
        title: 'Contact',
        intro: 'Get in touch to schedule a meeting or request the Data Room.'
      }
    },
    form: {
      name: 'Name',
      company: 'Organization',
      country: 'Country',
      interest: 'Interest',
      email: 'Email',
      message: 'Message',
      submit: 'Submit request',
      submitting: 'Submitting...',
      success: 'Request sent successfully',
      error: 'Error sending. Please try again.',
      interests: {
        offtake: 'Offtake',
        investment: 'Investment',
        epc: 'EPC-Tech',
        logistics: 'Logistics',
        institutional: 'Institutional'
      }
    },
    footer: {
      tagline: "The Caribbean's Green Gateway",
      description: 'Industrial-scale green hydrogen platform with strategic maritime connectivity.',
      copyright: '© 2026 Paraguana Hydrogen Gateway. All rights reserved.',
      privacy: 'Privacy Policy'
    }
  }
};